import { render, staticRenderFns } from "./UpdateTeams.vue?vue&type=template&id=39a72f0f&scoped=true&"
import script from "./UpdateTeams.vue?vue&type=script&lang=ts&"
export * from "./UpdateTeams.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateTeams.vue?vue&type=style&index=0&id=39a72f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a72f0f",
  null
  
)

export default component.exports